import reducer from './reducers';
export { default as selectors } from './selectors';
export { default as localesActions } from './actions';
export default reducer;
